import React, { useEffect } from 'react';
import useDevices from '../../hooks/useDevices';
import useMediaStreamTrack from '../../hooks/useMediaStreamTrack';
import useVideoContext from '../../hooks/useVideoContext';
import Select from '../../../../common/input/select';
import AudioVisualizer from "./AudioVisualizer";
import { Logger } from '../../utils';
import { SELECTED_AUDIO_INPUT_KEY } from '../../constants';


export default function AudioInputList() {
    const { audioInputDevices } = useDevices();
    const { localTracks } = useVideoContext();
    const localAudioTrack = localTracks.find(track => track.kind === 'audio');
    const mediaStreamTrack = useMediaStreamTrack(localAudioTrack);
    const localAudioInputDeviceId = mediaStreamTrack && mediaStreamTrack.getSettings() && mediaStreamTrack.getSettings().deviceId ? mediaStreamTrack.getSettings().deviceId : null;
    const renderedOptions = audioInputDevices.map(device => <option value={device.deviceId} key={device.deviceId}>{device.label}</option>);
    
    function replaceTrack(newDeviceId, localStorage = true) {
        if (localAudioTrack) {
            if (localStorage)
            window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
            localAudioTrack.restart({ deviceId: { exact: newDeviceId } });
            Logger(`UI.Twilio.Room.AudioInputDevice.OnChange`, new Date(), { newDeviceId: newDeviceId });
        }

    }

    useEffect(() => {
        let selectedAudioDeviceId = window.localStorage.getItem(SELECTED_AUDIO_INPUT_KEY);
        if (selectedAudioDeviceId) {
            // check if this device present in list
            const hasSelectedAudioDevice = audioInputDevices.some(device => device.deviceId === selectedAudioDeviceId);
            if (hasSelectedAudioDevice && localAudioInputDeviceId !== selectedAudioDeviceId) {
                replaceTrack(selectedAudioDeviceId, true);
            }
            else if (!hasSelectedAudioDevice) {
                if (audioInputDevices && audioInputDevices.length > 0 && audioInputDevices[0] && audioInputDevices[0].deviceId)
                    replaceTrack(audioInputDevices[0].deviceId, false);
            }
        }
    }, [JSON.stringify(audioInputDevices)]);

    return (
        <div className="row">
            <div className="col-12 form-group">
                <label className="label">Microphone</label>
                {audioInputDevices.length > 1 ?
                    <Select onChange={e => replaceTrack(e.target.value)} value={localAudioInputDeviceId || ""} renderedOptions={renderedOptions} disableEmptyOption />
                    : <label>{localAudioTrack && localAudioTrack.mediaStreamTrack.label || 'No Local Audio'}</label>
                }
            </div>
            <div className="col-12 form-group">               
                <AudioVisualizer />
            </div>
        </div>
    );
}
